import React from 'react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Mirás videos de YouTube sobre aires y nunca das el primer paso real', 'Cada mes te prometés que vas a arrancar por tu cuenta y no pasa nada', 'Tenés manos y ganas pero no tenés un sistema ni nadie que te guíe', 'Ves cómo otros técnicos se llenan de trabajo en temporada y vos esperás', 'Dejás el cuerpo en un trabajo que no te valora y el sueldo no cambia'];
export function PainPointsSection() {
  return <section className="py-10 md:py-16 px-4 bg-brand-deep" data-id="element-197">
      <div className="max-w-4xl mx-auto" data-id="element-198">
        <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-6 md:mb-10" data-id="element-199">
          Esto te va a sonar familiar:
        </h2>

        <div className="space-y-4 md:space-y-6 mb-8 md:mb-12 bg-white/5 backdrop-blur-sm p-5 md:p-8 rounded-2xl border border-white/10" data-id="element-200">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-3 md:gap-4" data-id="element-201">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-202">😤</span>
              <p className="text-base md:text-xl font-medium text-blue-100" data-id="element-203">
                {point}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-navy p-6 md:p-12 rounded-3xl border border-brand-primary/30 mb-8 md:mb-12 text-center shadow-sm" data-id="element-204">
          <h3 className="text-2xl md:text-4xl font-black text-white mb-4" data-id="element-205">
            El problema no sos vos.
          </h3>
          <h3 className="text-2xl md:text-4xl font-black text-brand-primary" data-id="element-206">
            El problema es que nadie te dio el método correcto.
          </h3>
        </div>

        <div className="text-center" data-id="element-207">
          <div className="max-w-xl mx-auto" data-id="element-208">
            <CTAButton text="→ QUIERO EL MÉTODO Y EMPEZAR HOY" href="#empezar" isLink={true} data-id="element-209" />
          </div>
        </div>
      </div>
    </section>;
}